import Container from "./MyInfoContainer";

export default Container;
